var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 21C38.75 30.8031 30.8031 38.75 21 38.75C11.1969 38.75 3.25 30.8031 3.25 21C3.25 11.1969 11.1969 3.25 21 3.25C30.8031 3.25 38.75 11.1969 38.75 21Z",
    stroke: "url(#paint0_linear_605_4317)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.75V21L28 28",
    stroke: "url(#paint1_linear_605_4317)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_4317",
    x1: 1.75,
    y1: 27.7812,
    x2: 38.817,
    y2: 8.41373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_605_4317",
    x1: 21,
    y1: 21.7656,
    x2: 29.2805,
    y2: 20.1923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.1d2be060d4b713852041a3fd6c39751b.svg";
export { ForwardRef as ReactComponent };